import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			rootInformation: {
				position: "relative",
				marginTop: -55,
				zIndex: 6,
				backgroundSize: "100% 100%",
				marginBottom: 5
			},
			rootBg: {
				background: theme.palette.common.white,
				boxShadow: " 0px 3px 29px rgba(114, 136, 128, 0.15)",
				borderRadius: 6,
				padding: 10,
				margin: "0px 16px"
			},
			avatar: {
				"& > img": {
					borderRadius: "50%",
					width: "100%"
				}
			},
			border: {
				borderTop: `1px solid ${theme.palette.grey[800]}`,
				margin: "10px 0px"
			}
		}),
	{
		name: "Information",
		index: 1
	}
);

export default useStyles;
